@if(loader){
<app-loader></app-loader>
}
<p-card>
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                    (click)="CreatePOrder()" pTooltip="Create Purchase Order"></p-button>

                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                            style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" class=" p-inputtext-sm"
                            (keyup.enter)="searchPO()" autocomplete="one-time-code" />
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchPO()" [ngStyle]="{ height: '35px' }" [raised]="true"
                        class="ml-2" [size]="'small'" severity="info">
                    </p-button>
                </div>
                <p-button *ngIf="selectedPOrder && selectedPOrder.length == 1" label="Edit" class="ml-2"
                    icon="pi pi-user-edit" (click)="editPOrder()" size="small" severity="secondary"></p-button>
                <p-button *ngIf="selectedPOrder && selectedPOrder.length > 0" label="Delete" class="ml-2"
                    icon="pi pi-trash" (click)="deletePOrder()" size="small" severity="danger"></p-button>

            </div>
            <h2 class="page-title-center">Purchase Order List</h2>


            <div class="flex align-items-center gap-2">
                <p-button (onClick)="sendOrderEmail()" label="Send Mail" class="p-button-outlined" icon="pi pi-envelope"
                    severity="info" size="small"></p-button>

                <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                    severity="info"></p-button>
            </div>
        </div>


        <p-table #dt1 [value]="result.purchaseOrder" [scrollable]="true" scrollHeight="630px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
            [paginator]="true" [rows]="10" (onPage)="loadPOrder($event)" [(selection)]="selectedPOrder"
            [globalFilterFields]="['purchaseOrderNumber','vendor.vendorCode','vendor.vendorName','warehouse.warehouseCode','poTotal','requestedDate','purchaseOrder_Status']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10 ,15, 20]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Purchase Order</th>
                    <th>PO Date</th>
                    <th *ngIf="hide">Project Name</th>
                    <!-- <th>Vendor Code</th> -->
                    <th>Vendor Name</th>
                    <!-- <th>Unit Code</th> -->
                    <th>{{unitLabel}} Name</th>
                    <th style="text-align: right;">PO Total</th>
                    <th>Req's Date</th>
                    <th pSortableColumn="purchaseOrder_Status">Status <p-sortIcon
                            field="purchaseOrder_Status"></p-sortIcon></th>
                    <th>Email Status</th>
                    <th>Created By</th>
                    <th>Print</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-purchaseOrder>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="purchaseOrder"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;"
                        (click)="editPOrder(purchaseOrder.purchaseOrderId)">
                        {{purchaseOrder.purchaseOrderNumber}}
                    </td>
                    <td>{{purchaseOrder.createdDate | date: 'dd/MM/yyyy' }}</td>
                    <td *ngIf="hide">
                        {{purchaseOrder.projectName}}
                    </td>

                    <!-- <td>{{purchaseOrder.vendor.vendorCode}}</td> -->
                    <td>{{purchaseOrder.vendor.vendorName}}</td>
                    <!-- <td>{{purchaseOrder.warehouse.warehouseCode}}</td> -->
                    <td>{{purchaseOrder.warehouse.warehouseName}}</td>
                    <td class="text-right"><span>₹ {{ purchaseOrder.poTotal.toLocaleString('en-IN',{
                            minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                    <td>{{purchaseOrder.requestedDate | date: 'dd/MM/yyyy' }}</td>
                    <!-- <td [ngStyle]="{
                        'color': purchaseOrder.purchaseOrder_Status === 'Close' ? '#0fdf00' :
                                 purchaseOrder.purchaseOrder_Status === 'Process' ? '#fa8202' :
                                 (purchaseOrder.purchaseOrder_Status === 'Rejected PR' || purchaseOrder.purchaseOrder_Status === 'Rejected PO')? 'red' :
                                 'blue'
                      }">{{purchaseOrder.purchaseOrder_Status}}</td> -->
                    <td [ngStyle]="{ 'color': statusColorMap[purchaseOrder.purchaseOrder_Status] }">
                        {{ purchaseOrder.purchaseOrder_Status }}
                    </td>
                    <td>
                        <span class="email-badge" [ngClass]="purchaseOrder.isEmailSent ? 'sent' : 'not-sent'">
                            {{ purchaseOrder.isEmailSent ? 'Sent' : 'Not Sent' }}
                        </span>
                    </td>
                    <td>{{purchaseOrder.createdBy}}</td>
                    <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                            (click)="showReport(purchaseOrder)"></span></td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>